<template lang="pug">
  .historial
    .card.table-panel(id='')
      .card-header
        h3.card-title
          | Historial
      .card-body.table-responsive
        table.table.table-bordered.table-condensed.table-striped.table-hover
          thead
            tr
              th.text-center.w-25 Fecha
              th.text-center.w-25 Evento
              th.text-center.w-25 Detalle
              th.text-center.w-25 Usuario
          tbody()
            tr( v-for='row in historial')
              td.text-center  {{row.fecha_evento}}
              td.text-center {{row.evento_codigo}}
              td.text-center {{row.descripcion}}
              td.text-center {{row.usuario_alta}}





</template>

<script>

import {HTTP} from "../http";

export default {
  name: "Historial",
  components: {},
  props: {
    rfi_id: {
      type: String,
    }
  },
  data() {
    return {
      historial: {},
    }
  },
  async created(){
    this.historial = (await HTTP.get('/historial/detalles', { params: {modulo_codigo: "SOLICITUD_INFORMACION", origen_id: this.rfi_id}})).data.list;
    console.log(this.historial)
  },
}
</script>

<style scoped>

</style>
